import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function Contact() {
  useEffect(() => { document.title = "Contact | ImpactVest"; window.scrollTo(0, 0); }, []);
  return (
    <div>
      <Header />
      <main className="pt-28 md:pt-36 pb-24" data-testid="page-contact">
        <div className="iv-container max-w-3xl">
          <div className="iv-eyebrow mb-6">Contact</div>
          <h1 className="font-serif-display text-[42px] md:text-[56px] leading-[1.02] tracking-tight text-iv-fg">
            Contact ImpactVest.
          </h1>
          <p className="mt-6 text-[15.5px] leading-relaxed text-iv-fg-2 max-w-2xl">
            ImpactVest is a product of Gaiosis Systems. The team behind the platform is small and
            focused. We answer every genuine enquiry.
          </p>

          <section className="mt-12 pt-8 border-t border-iv-line">
            <h2 className="font-serif-display text-[24px] md:text-[28px] leading-tight text-iv-fg mb-6">Primary contact</h2>
            <div className="space-y-4 text-[15px] leading-relaxed text-iv-fg-2">
              <p><b>General, product and press:</b><br />
                <a className="iv-link-underline" href="mailto:office@impactvest.com">office@impactvest.com</a></p>
              <p><b>Privacy and data-rights requests (Article 15 / 17 / 20 / 21 GDPR and equivalents):</b><br />
                <a className="iv-link-underline" href="mailto:office@impactvest.com">office@impactvest.com</a> — please put "Privacy request" in the subject line. We respond within 30 days.</p>
              <p><b>Security disclosure:</b><br />
                <a className="iv-link-underline" href="mailto:office@impactvest.com">office@impactvest.com</a> — please put "Security" in the subject line. We ask for responsible disclosure and will not pursue researchers acting in good faith.</p>
            </div>
          </section>

          <section className="mt-12 pt-8 border-t border-iv-line">
            <h2 className="font-serif-display text-[24px] md:text-[28px] leading-tight text-iv-fg mb-6">Legal identity</h2>
            <div className="space-y-3 text-[15px] leading-relaxed text-iv-fg-2">
              <p><b>Product brand:</b> ImpactVest.</p>
              <p><b>Merchant / DBA:</b> Gaiosis Systems.</p>
              <p><b>Billing statement descriptor:</b> GAIOSIS SYSTEMS.</p>
            </div>
            <p className="mt-4 font-mono text-[11px] tracking-[0.14em] uppercase text-iv-fg-3">
              Live payments are currently disabled.
            </p>
          </section>

          <section className="mt-12 pt-8 border-t border-iv-line">
            <h2 className="font-serif-display text-[24px] md:text-[28px] leading-tight text-iv-fg mb-6">Response times</h2>
            <ul className="space-y-2 list-disc ml-6 text-[15px] leading-relaxed text-iv-fg-2">
              <li>General enquiries: two business days.</li>
              <li>Privacy requests: 30 days maximum, usually sooner.</li>
              <li>Security disclosures: initial acknowledgement within two business days.</li>
            </ul>
          </section>

          <div className="mt-16 pt-8 border-t border-iv-line flex items-center justify-between gap-4 flex-wrap">
            <Link to="/legal/privacy" className="iv-link-underline text-[13.5px] text-iv-fg-2">Privacy Notice →</Link>
            <Link to="/legal/terms" className="iv-link-underline text-[13.5px] text-iv-fg-2">Terms of Use →</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
